<div class="alerts-page">
  <div class="alerts-header">
    <h1>Alerts</h1>

    <div class="header-actions">
      <label for="pageSize">Rows per page:</label>
      <select id="pageSize" (change)="onPageSizeChange($event)">
        <option [value]="5">5</option>
        <option [value]="10">10</option>
        <option [value]="20">20</option>
        <option [value]="50">50</option>
      </select>
    </div>
  </div>
  <div class="filters-bar">
    <input
      type="text"
      placeholder="Search"
      [value]="globalFilter()"
      (input)="onGlobalFilterChange($event)"
    />


    <button class="page-btn" (click)="clearFilters()">
      Clear
    </button>
  </div>

  <div class="alerts-card">
    @if (loading()) {
      <div class="state-message">Loading alerts...</div>
    }

    @if (error()) {
      <div class="state-message error">{{ error() }}</div>
    }

    @if (!loading() && !error()) {
      <div class="table-wrapper">
        <table class="alerts-table">
          <thead>
          <tr>
            <th class="sortable-header" (click)="sortBy('id')">
              <span>ID</span>
              <span class="sort-icon">{{ getSortIcon('id') }}</span>
            </th>
            <th>Legal Name</th>
            <th class="sortable-header" (click)="sortBy('generatedIn')">
              <span>Generated In</span>
              <span class="sort-icon">{{ getSortIcon('generatedIn') }}</span>
            </th>
            <th>Type</th>
            <th>Status</th>
            <th>Assignment</th>
            <th>Last Comment</th>
            <th>Latitude</th>
            <th>Longitude</th>
            <th>Involved Object</th>
            @if (hasAnyIncidentAction()) {
              <th>Actions</th>
            }
          </tr>
          </thead>

          <tbody>
            @if (paginatedAlerts().length > 0) {
              @for (alert of paginatedAlerts(); track alert.id) {
                <tr [class.alert-row-highlighted]="alert.id === highlightedAlertId()">
                  <td>{{ alert.id }}</td>
                  <td>{{ alert.legalName }}</td>
                  <td>{{ alert.generatedIn | date:'yyyy-MM-dd HH:mm:ss' }}</td>
                  <td>
                    @if (hasDetails(alert)) {
                      <button
                        type="button"
                        class="badge badge-button"
                        [ngClass]="getAlertTypeLabel(alert).toLowerCase()"
                        (click)="openDetailsModal(alert)"
                      >
                        {{ getAlertTypeLabel(alert) }}
                      </button>
                    } @else {
                        <span class="badge">
                          {{ getAlertTypeLabel(alert) }}
                        </span>
                    }
                  </td>
                  <td>
                    <span class="status-badge" [ngClass]="'status-' + (alert.status || 'NEW').toLowerCase()">
                      {{ getStatusLabel(alert) }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="assignment-badge"
                      [class.assigned]="getAssignmentIndicator(alert) === 'Assigned'"
                    >
                      {{ getAssignmentIndicator(alert) }}
                    </span>
                  </td>
                  <td>{{ getLastCommentLabel(alert) }}</td>
                  <td>{{ alert.latitude ?? '-' }}</td>
                  <td>{{ alert.longitude ?? '-' }}</td>
                  <td>
                    @if (hasInvolvedObject(alert)) {
                      <button
                        type="button"
                        class="involved-object-btn"
                        (click)="openInvolvedObjectModal(alert)"
                      >
                        {{ getInvolvedObjectButtonLabel(alert) }}
                      </button>
                    } @else {
                      <span>-</span>
                    }
                  </td>
                  @if (hasAnyIncidentAction()) {
                    <td>
                      <div class="alert-action-row">
                        @if (canViewIncidentAudit()) {
                          <button class="audit-btn" (click)="openAuditModal(alert)">
                            Audit
                          </button>
                        }
                        @if (canCommentOnIncident()) {
                          <button class="comment-btn" (click)="openCommentModal(alert)">
                            Comment
                          </button>
                        }
                        @if (canAssignAlerts()) {
                          <button class="assign-btn" (click)="openAssignmentModal(alert)">
                            Assign
                          </button>
                        }
                        @if (canDeleteAlert()) {
                          <button class="delete-btn" (click)="openDeleteModal(alert.id)">
                            Delete
                          </button>
                        }
                      </div>
                    </td>
                  }
                </tr>
              }
            } @else {
              <tr>
                <td colspan="12" class="empty-row">No alerts found.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    @if (!loading() && totalItems() > 0) {
      <div class="pagination">
        <div class="pagination-info">
          Showing
          {{ (currentPage() - 1) * pageSize() + 1 }}
          -
          {{ Math.min(currentPage() * pageSize(), totalItems()) }}
          of
          {{ totalItems() }} alerts
        </div>

        <div class="pagination-controls">
          <button
            class="page-btn"
            (click)="previousPage()"
            [disabled]="currentPage() === 1"
          >
            Previous
          </button>

          @for (page of pageNumbers(); track page) {
            <button
              class="page-btn"
              (click)="goToPage(page)"
              [class.active]="page === currentPage()"
            >
              {{ page }}
            </button>
          }

          <button
            class="page-btn"
            (click)="nextPage()"
            [disabled]="currentPage() === totalPages()"
          >
            Next
          </button>
        </div>
      </div>
    }
  </div>

  <div class="grafana-section">
    <app-grafana-embed
      [src]="grafanaIncidents"
      [height]="900"
    ></app-grafana-embed>
  </div>
</div>

@if (deleteModalOpen()) {
  <div class="modal-backdrop" (click)="closeDeleteModal()">
    <div class="confirm-modal" (click)="$event.stopPropagation()">
      <div class="confirm-modal-header">
        <h2>Delete alert</h2>
      </div>

      <div class="confirm-modal-body">
        <p>Are you sure you want to delete this alert?</p>
        <p class="modal-warning">This action cannot be undone.</p>
      </div>

      <div class="confirm-modal-actions">
        <button class="modal-btn secondary" (click)="closeDeleteModal()">
          Cancel
        </button>
        <button class="modal-btn danger" (click)="confirmDelete()">
          Delete
        </button>
      </div>
    </div>
  </div>
}

@if (auditModalOpen() && selectedAuditAlert(); as alert) {
  <div class="modal-backdrop" (click)="closeAuditModal()">
    <div class="details-modal audit-modal" (click)="$event.stopPropagation()">
      <div class="confirm-modal-header">
        <h2>Audit for alert #{{ alert.id }}</h2>
      </div>

      <div class="details-modal-body">
        @if (auditLoading()) {
          <div class="state-message">Loading audit...</div>
        }

        @if (auditError()) {
          <div class="state-message error">{{ auditError() }}</div>
        }

        @if (!auditLoading() && !auditError()) {
          @if (auditEntries().length) {
            <div class="audit-list">
              @for (entry of auditEntries(); track entry.id) {
                <p class="audit-entry">
                  @if (entry.actionType === 'STATUS_CHANGED') {
                    <strong>{{ entry.performedByUsername }}</strong>
                    changed this alert status from
                    <strong>{{ entry.oldStatus?.replaceAll('_', ' ') }}</strong>
                    to
                    <strong>{{ entry.newStatus?.replaceAll('_', ' ') }}</strong>
                    on
                    <strong>{{ entry.createdAt | date:'yyyy-MM-dd HH:mm:ss' }}</strong>.
                  } @else if (entry.actionType === 'COMMENTED') {
                    <strong>{{ entry.performedByUsername }}</strong>
                    commented
                    <strong>"{{ entry.commentText }}"</strong>
                    on
                    <strong>{{ entry.createdAt | date:'yyyy-MM-dd HH:mm:ss' }}</strong>.
                  } @else if (entry.actionType === 'FEEDBACK_GIVEN') {
                    <strong>{{ entry.performedByUsername }}</strong>
                    gave feedback with rating
                    <strong>{{ entry.feedbackRating }}/5</strong>:
                    <strong>"{{ entry.feedbackMessage }}"</strong>
                    on
                    <strong>{{ entry.createdAt | date:'yyyy-MM-dd HH:mm:ss' }}</strong>.
                  } @else {
                    <strong>{{ entry.performedByUsername }}</strong>
                    {{ getAuditActionLabel(entry) }}
                    <strong>{{ getAuditTargetLabel(entry) }} {{ entry.targetName }}</strong>
                    on
                    <strong>{{ entry.createdAt | date:'yyyy-MM-dd HH:mm:ss' }}</strong>.
                  }
                </p>
              }
            </div>
          } @else {
            <p class="empty-details">No audit entries found for this alert.</p>
          }
        }
      </div>

      <div class="confirm-modal-actions">
        <button class="modal-btn secondary" (click)="closeAuditModal()">
          Close
        </button>
      </div>
    </div>
  </div>
}

@if (commentModalOpen() && selectedCommentAlert(); as alert) {
  <div class="modal-backdrop" (click)="closeCommentModal()">
    <div class="confirm-modal comment-modal" (click)="$event.stopPropagation()">
      <div class="confirm-modal-header">
        <h2>Comment on alert #{{ alert.id }}</h2>
      </div>

      <div class="details-modal-body">
        @if (commentError()) {
          <div class="state-message error">{{ commentError() }}</div>
        }

        <textarea
          class="modal-textarea"
          placeholder="Write a comment"
          [value]="commentText()"
          (input)="commentText.set($any($event.target).value)"
        ></textarea>
      </div>

      <div class="confirm-modal-actions">
        <button class="modal-btn secondary" (click)="closeCommentModal()" [disabled]="commentSaving()">Cancel</button>
        <button class="modal-btn primary" (click)="saveComment()" [disabled]="commentSaving()">Save</button>
      </div>
    </div>
  </div>
}

@if (assignmentModalOpen() && selectedAssignmentAlert(); as alert) {
  <div class="modal-backdrop" (click)="closeAssignmentModal()">
    <div class="details-modal assignment-modal" (click)="$event.stopPropagation()">
      <div class="confirm-modal-header">
        <h2>Assign alert #{{ alert.id }}</h2>
      </div>

      <div class="details-modal-body">
        @if (assignmentLoading()) {
          <div class="state-message">Loading assignment data...</div>
        }

        @if (assignmentError()) {
          <div class="state-message error">{{ assignmentError() }}</div>
        }

        @if (!assignmentLoading()) {
          <div class="assignment-section">
            <h3>Already assigned users</h3>

            @if (assignedUsers().length) {
              <div class="assignment-list">
                @for (assignment of assignedUsers(); track assignment.id) {
                  <div class="assignment-row">
                    <span>{{ assignment.assigneeName }}</span>
                    <button
                      type="button"
                      class="modal-btn danger compact"
                      [disabled]="assignmentSaving()"
                      (click)="removeAssignment(assignment)"
                    >
                      Remove
                    </button>
                  </div>
                }
              </div>
            } @else {
              <p class="empty-details">No assigned users.</p>
            }
          </div>

          <div class="assignment-section">
            <h3>Already assigned organizations</h3>

            @if (assignedOrganizations().length) {
              <div class="assignment-list">
                @for (assignment of assignedOrganizations(); track assignment.id) {
                  <div class="assignment-row">
                    <span>{{ assignment.assigneeName }}</span>
                    <button
                      type="button"
                      class="modal-btn danger compact"
                      [disabled]="assignmentSaving()"
                      (click)="removeAssignment(assignment)"
                    >
                      Remove
                    </button>
                  </div>
                }
              </div>
            } @else {
              <p class="empty-details">No assigned organizations.</p>
            }
          </div>

          <div class="assignment-section">
            <h3>Add users</h3>

            @if (usersAvailableForAssignment().length) {
              <div class="checkbox-list">
                @for (user of usersAvailableForAssignment(); track user.id) {
                  <label class="checkbox-row">
                    <input
                      type="checkbox"
                      [checked]="isUserSelected(user.id)"
                      (change)="toggleUserSelection(user.id, $event)"
                    />
                    <span>{{ user.username }}</span>
                  </label>
                }
              </div>
            } @else {
              <p class="empty-details">No users available for assignment.</p>
            }
          </div>

          <div class="assignment-section">
            <h3>Add organizations</h3>

            @if (organizationsAvailableForAssignment().length) {
              <div class="checkbox-list">
                @for (organization of organizationsAvailableForAssignment(); track organization.id) {
                  <label class="checkbox-row">
                    <input
                      type="checkbox"
                      [checked]="isOrganizationSelected(organization.id)"
                      (change)="toggleOrganizationSelection(organization.id, $event)"
                    />
                    <span>{{ organization.name }}</span>
                  </label>
                }
              </div>
            } @else {
              <p class="empty-details">No organizations available for assignment.</p>
            }
          </div>
        }
      </div>

      <div class="confirm-modal-actions">
        <button class="modal-btn secondary" (click)="closeAssignmentModal()" [disabled]="assignmentSaving()">
          Close
        </button>
        <button
          class="modal-btn primary"
          (click)="saveAssignments()"
          [disabled]="assignmentLoading() || assignmentSaving()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
}

@if (detailsModalOpen() && selectedAlert(); as alert) {
  <div class="modal-backdrop" (click)="closeDetailsModal()">
    <div class="details-modal" (click)="$event.stopPropagation()">
      <div class="confirm-modal-header">
        <h2>
          @if (alert.anomaly) {
            Anomaly details
          } @else if (alert.intentions.length) {
            Intentions details
          } @else {
            Alert details
          }
        </h2>
      </div>

      <div class="details-modal-body">
        @if (alert.anomaly; as anomaly) {
          <div class="details-list">
            <div class="details-list-item">
              <div class="detail-row">
                <span class="detail-label">Anomaly type</span>
                <span class="detail-value">{{ anomaly.anomalyType }}</span>
              </div>

              <div class="detail-row">
                <span class="detail-label">Anomaly score</span>
                <span class="detail-value">{{ anomaly.anomalyScore * 100 }}%</span>
              </div>

              <div class="detail-row">
                <span class="detail-label">Explanation</span>
                <span class="detail-value">{{ anomaly.explanation }}</span>
              </div>
            </div>
          </div>
        } @else if (alert.intentions.length) {
          <div class="details-list">
            @for (intention of alert.intentions; track $index) {
              <div class="details-list-item">
                <div class="detail-row">
                  <span class="detail-label">Classification</span>
                  <span class="detail-value">{{ intention.classification }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Probability</span>
                  <span class="detail-value">{{ intention.probability * 100 }}%</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Explanation</span>
                  <span class="detail-value">{{ intention.explanation }}</span>
                </div>
              </div>
            }
          </div>
        } @else {
          <p class="empty-details">No details available.</p>
        }
      </div>

      <div class="confirm-modal-actions">
        <button class="modal-btn secondary" (click)="closeDetailsModal()">
          Close
        </button>
      </div>
    </div>
  </div>
}

@if (involvedObjectModalOpen()) {
  <div class="modal-backdrop" (click)="closeInvolvedObjectModal()">
    <div class="details-modal" (click)="$event.stopPropagation()">
      <div class="confirm-modal-header">
        <h2>Involved object details</h2>
      </div>

      <div class="details-modal-body">
        @if (involvedObjectLoading()) {
          <div class="state-message">Loading details...</div>
        }

        @if (involvedObjectError()) {
          <div class="state-message error">{{ involvedObjectError() }}</div>
        }

        @if (!involvedObjectLoading() && !involvedObjectError()) {
          @if (selectedInvolvedObjectType() === 'vessel' && selectedVessel(); as vessel) {
            <div class="details-list">
              <div class="details-list-item">
                <div class="detail-row">
                  <span class="detail-label">Type</span>
                  <span class="detail-value">Vessel</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">ID</span>
                  <span class="detail-value">{{ vessel.id }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Legal Name</span>
                  <span class="detail-value">{{ vessel.legalName ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Generated In</span>
                  <span class="detail-value">
                    {{ vessel.generatedIn ? (vessel.generatedIn | date:'yyyy-MM-dd HH:mm:ss') : '-' }}
                  </span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">UUID</span>
                  <span class="detail-value">{{ vessel.uuid ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Latitude</span>
                  <span class="detail-value">{{ vessel.latitude ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Longitude</span>
                  <span class="detail-value">{{ vessel.longitude ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Name</span>
                  <span class="detail-value">{{ vessel.name ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">COG</span>
                  <span class="detail-value">{{ vessel.cog ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Heading</span>
                  <span class="detail-value">{{ vessel.heading ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Speed</span>
                  <span class="detail-value">{{ vessel.speed ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Breadth</span>
                  <span class="detail-value">{{ vessel.breadth ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Callsign</span>
                  <span class="detail-value">{{ vessel.callsign ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Depth</span>
                  <span class="detail-value">{{ vessel.depth ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Draught</span>
                  <span class="detail-value">{{ vessel.draught ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Length</span>
                  <span class="detail-value">{{ vessel.length ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">MMSI</span>
                  <span class="detail-value">{{ vessel.mmsi ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Navigational Status</span>
                  <span class="detail-value">{{ vessel.navigationalStatus ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">AIS Ship Type</span>
                  <span class="detail-value">{{ vessel.aisShipType ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Source Type</span>
                  <span class="detail-value">{{ vessel.sourceType ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Track ID</span>
                  <span class="detail-value">{{ vessel.trackId ?? '-' }}</span>
                </div>
              </div>
            </div>
          }

          @if (selectedInvolvedObjectType() === 'object' && selectedObject(); as objectDetails) {
            <div class="details-list">
              <div class="details-list-item">
                <div class="detail-row">
                  <span class="detail-label">Type</span>
                  <span class="detail-value">Object</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">ID</span>
                  <span class="detail-value">{{ objectDetails.id }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Legal Name</span>
                  <span class="detail-value">{{ objectDetails.legalName ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Generated In</span>
                  <span class="detail-value">
                    {{ objectDetails.generatedIn ? (objectDetails.generatedIn | date:'yyyy-MM-dd HH:mm:ss') : '-' }}
                  </span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">UUID</span>
                  <span class="detail-value">{{ objectDetails.uuid ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Latitude</span>
                  <span class="detail-value">{{ objectDetails.latitude ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Longitude</span>
                  <span class="detail-value">{{ objectDetails.longitude ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Location Uncertainty</span>
                  <span class="detail-value">{{ objectDetails.locationUncertainty ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Source Type</span>
                  <span class="detail-value">{{ objectDetails.sourceType ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Track ID</span>
                  <span class="detail-value">{{ objectDetails.trackId ?? '-' }}</span>
                </div>

                <div class="detail-row">
                  <span class="detail-label">Category</span>
                  <span class="detail-value">{{ objectDetails.category ?? '-' }}</span>
                </div>
              </div>
            </div>
          }
        }
      </div>

      <div class="confirm-modal-actions">
        <button class="modal-btn secondary" (click)="closeInvolvedObjectModal()">
          Close
        </button>
      </div>
    </div>
  </div>
}
